var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrival-time-picker"},[_c('time-picker',{attrs:{"label":"Förväntad ankomsttid","allowed-minutes":[0, 15, 30, 45]},model:{value:(_vm.timePickerValue),callback:function ($$v) {_vm.timePickerValue=$$v},expression:"timePickerValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }